// New file: components/Dashboard/AverageWinMetric.js
import React from "react";
import { TrendingUp } from "lucide-react";

const AverageWinMetric = ({ trades }) => {
  const calculateAverageWin = (trades) => {
    const winningTrades = trades.filter((trade) => trade.pnl > 0);
    if (winningTrades.length === 0) return 0;

    const avgWinPercent =
      winningTrades.reduce((sum, trade) => {
        const percentReturn =
          ((trade.exitPrice - trade.entryPrice) / trade.entryPrice) * 100;
        return sum + percentReturn;
      }, 0) / winningTrades.length;

    return avgWinPercent.toFixed(2);
  };

  return (
    <div className="metric-card">
      <div className="metric-header">
        <h3>Average Win %</h3>
        <TrendingUp size={20} className="metric-icon" />
      </div>
      <div className="metric-content">
        <span className="metric-value profit">
          +{calculateAverageWin(trades)}%
        </span>
        <span className="metric-subtitle">Average Return on Winners</span>
      </div>
    </div>
  );
};

export default AverageWinMetric;
